import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { Kbd, KbdGroup } from "../components/ui/kbd"
import { cn } from "../lib/utils"
import { liftV4Props } from "./element-renderer"

export function KbdRenderer({ element }: RendererProps) {
  const { resolveSymbol } = useRenderContext()

  // Multiple keys: render as KbdGroup with individual Kbd elements
  if (element.children && element.children.length > 0) {
    return (
      <KbdGroup
        className={cn(element.className)}
        data-testid={`kbd-group-${element.id}`}
      >
        {element.children.map((rawChild) => {
          // JITRULE Task 2: key children may nest `text` under `props`.
          const child = liftV4Props(rawChild)
          const keyText = child.text
            ? String(resolveSymbol(child.text) ?? "")
            : ""
          return <Kbd key={child.id}>{keyText}</Kbd>
        })}
      </KbdGroup>
    )
  }

  // Single key
  const text = element.text
    ? String(resolveSymbol(element.text) ?? "")
    : ""

  return (
    <Kbd
      className={cn(element.className)}
      data-testid={`kbd-${element.id}`}
    >
      {text}
    </Kbd>
  )
}
